import type {
    TAssetTypeCode,
    TProfitabilityType,
    IAssetCategory,
    TConfigUrlToAssetTemplatePage,
} from './models';
import {
    ASSET_NAME_BOND,
    ASSET_NAME_STOCK,
    ASSET_NAME_CURRENCY,
    ASSET_NAME_FOND,
    ASSET_NAME_INDEX,
    PROFITABILITY_TYPE_DAY,
    PROFITABILITY_TYPE_WEEK,
    PROFITABILITY_TYPE_MONTH,
    PROFITABILITY_TYPE_THREEMONTHS,
    PROFITABILITY_TYPE_YEAR,
    PROFITABILITY_TYPE_YTM,
} from './constants';

export { tags } from './components/sortable/config';

export const defaultNotFoundFeedBlockSettings = {
    title: 'Данные не могут быть отображены',
    description:
        'Ведутся технические работы по устранению ошибки. Приносим свои извинения, скоро всё заработает.',
};

export const defaultConfigUrlToAssetTemplatePage: TConfigUrlToAssetTemplatePage = {
    [ASSET_NAME_CURRENCY]: '/make-money/investments/catalog/currencies/t/',
    [ASSET_NAME_FOND]: '/make-money/investments/catalog/fondy/t/',
    [ASSET_NAME_INDEX]: '/make-money/investments/catalog/indeks/t/',
    [ASSET_NAME_STOCK]: '/make-money/investments/catalog/akcii/t/',
    [ASSET_NAME_BOND]: '/make-money/investments/catalog/obligacii/t/',
};

export const sortableFields = {
    profitabilityPercent: 'profitabilityPercent',
    shortName: 'shortName',
    lastPrice: 'last_price',
    bondMaturityDate: 'bondMaturityDate',
} as const;

/** Конфигурация тегов/табов для разных типов ассетов */
export const assetTypesForTags: Record<TAssetTypeCode, IAssetCategory> = {
    [ASSET_NAME_STOCK]: { label: 'Акции', value: ASSET_NAME_STOCK },
    [ASSET_NAME_BOND]: { label: 'Облигации', value: ASSET_NAME_BOND },
    [ASSET_NAME_CURRENCY]: { label: 'Валюты', value: ASSET_NAME_CURRENCY },
    [ASSET_NAME_FOND]: { label: 'Фонды', value: ASSET_NAME_FOND },
    [ASSET_NAME_INDEX]: { label: 'Индексы', value: ASSET_NAME_INDEX },
};

/** Конфиг для дефолтных типов доходности */
export const mapDefaultProfitabilityPeriod: Record<TAssetTypeCode, TProfitabilityType> = {
    [ASSET_NAME_BOND]: PROFITABILITY_TYPE_YTM,
    [ASSET_NAME_STOCK]: PROFITABILITY_TYPE_MONTH,
    [ASSET_NAME_CURRENCY]: PROFITABILITY_TYPE_DAY,
    [ASSET_NAME_FOND]: PROFITABILITY_TYPE_MONTH,
    [ASSET_NAME_INDEX]: PROFITABILITY_TYPE_DAY,
};

/** Массив с типами доходностей */
export const profitabilityTypes: TProfitabilityType[] = [
    PROFITABILITY_TYPE_DAY,
    PROFITABILITY_TYPE_WEEK,
    PROFITABILITY_TYPE_MONTH,
    PROFITABILITY_TYPE_THREEMONTHS,
    PROFITABILITY_TYPE_YEAR,
];

interface IProfitabilityTypeInput {
    label: string;
    value: TProfitabilityType;
}

// @ts-ignore PROFITABILITY_TYPE_YTM тут не нужен
export const profitabilityTypesForInput: IProfitabilityTypeInput[] = [
    { label: 'За 1 день', value: PROFITABILITY_TYPE_DAY },
    { label: 'За 1 неделю', value: PROFITABILITY_TYPE_WEEK },
    { label: 'За 1 месяц', value: PROFITABILITY_TYPE_MONTH },
    {
        label: 'За 3 месяца',
        value: PROFITABILITY_TYPE_THREEMONTHS,
    },
    { label: 'За 1 год', value: PROFITABILITY_TYPE_YEAR },
];
